import { Link } from "react-router-dom";
import { BRAND, NAV } from "../../lib/site";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#050B14] pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <img src={BRAND.logo} alt="Yes Global" className="h-11 w-11 rounded-full ring-1 ring-white/20" />
              <span className="font-display text-xl font-bold text-white">YES GLOBAL CONSULTANTS</span>
            </div>
            <p className="font-body text-white/50 max-w-sm leading-relaxed">
              Executive search & HR consulting, headquartered in New Delhi — placing elite leadership across India, the UAE and the US.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] text-white/40 mb-5">EXPLORE</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="font-body text-white/70 hover:text-[#00D166] transition-colors">{n.label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <p className="font-body text-xs tracking-[0.3em] text-white/40 mb-5">CONTACT</p>
            <ul className="space-y-3 font-body text-white/70">
              <li><a href={`tel:${BRAND.phone}`} className="hover:text-[#00D166] transition-colors">{BRAND.phone}</a></li>
              <li><a href={`mailto:${BRAND.email}`} className="hover:text-[#00D166] transition-colors">{BRAND.email}</a></li>
              <li>{BRAND.location}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">Copyright © 2026 Yes Global Consultants. All Rights Reserved</p>
          <Link to="/admin" data-testid="footer-admin-link" className="font-body text-xs text-white/30 hover:text-[#00D166] transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
